import tags from "../../../../components/tags";
import { icons } from "../../../../components/html";
import { statusCodes } from "../../../../components/responses";

export default {
  "/client/people/size-advisor/{id}": {
    get: {
      tags: [tags.businessAccount],
      summary: "Size advisor for connected user.",
      description: `${icons.c}
      Returns Size advisor for connected users, which match the selected filters.`,
      parameters: [
        { $ref: "#/components/parameters/acceptsLanguages" },
        { $ref: "#/components/parameters/tableId" },
        { $ref: "#/components/parameters/userEmailFilter" },
        { $ref: "#/components/parameters/gender" },
        { $ref: "#/components/parameters/limit" },
        { $ref: "#/components/parameters/offset" }
      ],

      responses: {
        "200": {
          content: {
            "application/json": {
              schema: {
                type: "array",
                items: {
                  type: "object",
                  properties: {
                    recommended_size_index: {
                      type: "number",
                      description: "index of recommended size in sizes array",
                      example: 3
                    },
                    user: {
                      $ref: "#/components/schemas/user"
                    },
                    error: {
                      type: "boolean|integer",
                      description: "while recommending error occurred",
                      example: "false"
                    },
                    sizes: {
                      $ref: "#/components/schemas/recommendedSize"
                    }
                  }
                }
              }
            }
          }
        },
        ...statusCodes
      }
    }
  }
};
